import * as React from 'react';
import { DetailsLine } from './DetailsLine';
import TxpDataRow from 'txp-data/lib/schema/viewSchema/TxpDataRow';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import PostalAddress from 'txp-data/lib/schema/innerSchema/PostalAddress';
import { CardMode } from 'txp-data/lib/schema/viewSchema/CardMode';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import EditableLocationPicker from './EditableLocationPicker';

let style = require('./Txp.scss');

export interface DetailsEditCardProps {
    cardMode: CardMode;
    txpStyle: TxpStyle;
    readOnlyLines: TxpDataRow[];
    editableText: string;
    editableData: TxpDataRow;
    location: PostalAddress;
    onLocationChanged?: (location: PostalAddress, stringAddress: string) => void;
    getDisplayAddress?: (location: PostalAddress) => string;
}

const DetailsEdit = (props: DetailsEditCardProps) => {
    let {
        txpStyle,
        readOnlyLines,
        onLocationChanged,
        editableText,
        cardMode,
        editableData,
        location,
        getDisplayAddress,
    } = props;
    let { icon } = editableData;

    let detailsLines = readOnlyLines.map((TxpDataRow, index) => {
        let isLocationIcon = TxpDataRow && TxpDataRow.icon === ControlIcons.Poi;
        return (
            <div className={style.detailsEditContainer}>
                {isLocationIcon && <Icon className={style.iconStyle} iconName={TxpDataRow.icon} />}
                <DetailsLine
                    key={index}
                    detailsData={TxpDataRow}
                    txpStyle={txpStyle}
                    isFlightCardLine={false}
                />
            </div>
        );
    });

    return (
        <div>
            {detailsLines}
            <div className={style.editableLocationContainer}>
                <Icon className={style.detailsEditButton} iconName={icon} />
                <EditableLocationPicker
                    onLocationChanged={onLocationChanged}
                    editableText={editableText}
                    editableData={editableData}
                    location={location}
                    cardMode={cardMode}
                    getDisplayAddress={getDisplayAddress}
                />
            </div>
        </div>
    );
};

export default DetailsEdit;
